// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.15 1.75V5.15C6.15 5.72 6 6.11 5.72 6.58L2.53 11.98C1.89 13.08 2.55 14.25 3.83 14.25H12.17C13.45 14.25 14.11 13.08 13.47 11.98L10.28 6.58C10 6.11 9.85 5.72 9.85 5.15V1.75',
  'M5.25 1.75H10.75',
  'M3.55 10.25C6.52 8.88 8.22 11.62 12.45 10.25',
];
